import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { EnumAccountType } from '@/services/auth/auth';

import { useProfile } from './useProfile';

export const useRedirectAuthUsers = () => {
  const { pathname, replace } = useRouter();
  const { data } = useProfile();

  const isCustomerOrRecruiter =
    data &&
    (data?.accountType === EnumAccountType.CUSTOMER ||
      data?.accountType === EnumAccountType.RECRUITER);

  const isCandidate = data && data?.accountType === EnumAccountType.CANDIDATE;
  useEffect(() => {
    if (
      (!pathname.includes('/dashboard') ||
        pathname.includes('/dashboard/auth')) &&
      isCustomerOrRecruiter
    ) {
      replace('/dashboard');
    }
    if (pathname.includes('/dashboard') && isCandidate) {
      replace('/builder');
    }
  }, [data, pathname]);
};
